import { Component, ViewChild } from '@angular/core';
import { PopoverController, ViewController, NavController, ModalController, Events, Tabs, NavParams, LoadingController, AlertController, Platform } from 'ionic-angular';

import { HomePage } from '../home/home';
import { MaisempresaPage } from '../home/home';
import { TutorialqrcodePage } from '../home/home';

import { CartaofidelidadePage } from '../cartaofidelidade/cartaofidelidade';
import { DadosPage } from '../dados/dados';
import { EmpresaPage } from '../empresa/empresa';
import { RegrasPage } from '../regras/regras';
import { MensagensPage } from '../mensagens/mensagens';
import { HistoricoPage } from '../historico/historico';
import { SobrePage } from '../sobre/sobre';
import { LoginPage } from '../login/login';
import { LinguaPage } from '../lingua/lingua';

import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';
import { Storage } from '@ionic/storage';

import { SocialSharing } from '@ionic-native/social-sharing';

import { ApiProvider } from '../../providers/api/api';


@Component({
	selector: 'page-tabs',
	templateUrl: 'tabs.html',
})

export class TabsPage {
	tab1Root      = HomePage;
	tab2Root      = MaisempresaPage;
	id_cliente    = 0;
	mostrarQrcode = false;
	carregou      = false;

	@ViewChild('myTabs') tabRef: Tabs;

	constructor(
        public  popoverCtrl  : PopoverController,
        public  events       : Events,
        public  nav          : NavController,
        private socialSharing: SocialSharing,
        private storage      : Storage,
        private _api         : ApiProvider,
        public  params       : NavParams,
        public  modalCtrl    : ModalController,
        private loadingCtrl  : LoadingController,
        private _msg         : TranslateMsgProvider,
        private alertCtrl    : AlertController,
        public  platform     : Platform,
        )
	{
        if(!this.platform.is('core')){
            this.mostrarQrcode = true;
        }
        this.carregou = true;
    }

    ionViewDidEnter()
    {
        
        this.events.unsubscribe('gotopage');

        this.events.subscribe('gotopage', (dados) =>
        {
            this.openPage(dados);
        });

        this.events.unsubscribe('gotobusca');
		this.events.subscribe('gotobusca', (dados) =>
        {
            this.tabRef.select(1);
        });

        // Verifica se é para abrir o chat
        let tipo = this.params.get('tipo');
        if(tipo == 'mensagem')
        {
            this.storage.set('id_empresa_escolhida', this.params.get('id'));
            this.storage.set('mensagem', 1);
            this.events.publish('gotopage2', {page: MensagensPage, id: this.params.get('id')});
        }

        this.storage.get('id_cliente').then((val) => {
            this.id_cliente = val;
        });
    }

    openPage(dados)
    {
        let page = this.tabRef.getSelected();
        if((page.index != 0) && (page.index != 1))
        {
            this.tabRef.select(0);
        }

    	page = this.tabRef.getSelected();
        if(page.index == 0)
        {
            this.events.publish('gotopage2', dados);
        }
        else
        {
            this.events.publish('gotopage3', dados);
        }
    }

    shareApp()
    {
        this.storage.get('id_empresa_escolhida').then((emp) => {
            this._api.share({id_empresa: emp}).subscribe(arg=>{
                this.socialSharing.share(arg.message, arg.subject, arg.image, arg.url);
            });
        });
    }

	presentPopover(myEvent) {
		let popover = this.popoverCtrl.create(PopoverPage);
		popover.present({
			ev: {target: myEvent.btn._elementRef.nativeElement}
		});
	}

    QrCode(event)
    {
        let modalTutorial = this.modalCtrl.create(TutorialqrcodePage);
        modalTutorial.onDidDismiss(data => {
            this.ganharPontoQrcode(data);
        });
        modalTutorial.present();
    }

    private ganharPontoQrcode(data)
    {
        if(data.text != '')
        {
            let loading = this.loadingCtrl.create({
                        content: this._msg.getMsg('CARREGANDO')+'...',
                        dismissOnPageChange: true
                    });
            loading.present();

            let envio;
            if(data.adiciona)
            {
                envio = {id_cliente: this.id_cliente, qrcode: data.text, adiciona: true};
            }
            else
            {
                envio = {id_cliente: this.id_cliente, qrcode: data.text};
            }

            this._api.setPontoQrcode(envio).subscribe(arg=>{
                loading.dismiss();
                
                let titulo = '';
                let tex = '';


                if(arg.erro)
                {
                    if(arg.erro == '009')
                    {
                        const confirm = this.alertCtrl.create({
                            title: this._msg.getMsg('CARTAO_PARTICIPAR', arg.empresa),
                            message: this._msg.getMsg('CARTAO_PARTICIPAR_DESC'),
                            buttons: [
                            {
                                text: this._msg.getMsg('NAO'),
                                handler: () => {
                                }
                            },
                            {
                                text: this._msg.getMsg('CARTAO_PARTICIPAR_SIM'),
                                handler: () => {
                                    data.adiciona = true;
                                    this.ganharPontoQrcode(data);
                                }
                            }
                            ]
                        });
                        confirm.present();
                        return false;
                    }
                    titulo = 'Erro '+arg.erro;
                    tex = arg.msg;
                }
                else if(!arg.completo)
                {
                    let pontos = (arg.total_pontos - arg.pontos);
                    let txt = '';

                    if(pontos == 1)
                    {
                        txt = this._msg.getMsg('CARTAO_UM_PONTO');
                    }
                    else
                    {
                        txt = this._msg.getMsg('CARTAO_FALTA_PONTOS', String(pontos));
                    }

                    titulo = arg.empresa;
                    tex = this._msg.getMsg('CARTAO_AVISO_ADICIONADO', txt);
                }
                else if(arg.completo)
                {
                    titulo = arg.empresa;
                    tex = this._msg.getMsg('CARTAO_PARABENS');
                }

                let alert = this.alertCtrl.create({
                        title: titulo,
                        subTitle: tex,
                        buttons: [
                        {
                            text: 'OK'
                        }
                        ]
                    });
                alert.present();
                window.location.reload();
                
            });

            this._api.zerarPontoQrcode(envio).subscribe(arg=>{
                loading.dismiss();
                
                let titulo = '';
                let tex = '';


                if(arg.erro)
                {
                    if(arg.erro == '009')
                    {
                        const confirm = this.alertCtrl.create({
                            title: this._msg.getMsg('CARTAO_PARTICIPAR', arg.empresa),
                            message: this._msg.getMsg('CARTAO_PARTICIPAR_DESC'),
                            buttons: [
                            {
                                text: this._msg.getMsg('NAO'),
                                handler: () => {
                                    console.info('Disagree clicked');
                                }
                            },
                            {
                                text: this._msg.getMsg('CARTAO_PARTICIPAR_SIM'),
                                handler: () => {
                                    console.info('Agree clicked');
                                    data.adiciona = true;
                                    this.ganharPontoQrcode(data);
                                }
                            }
                            ]
                        });
                        confirm.present();
                        return false;
                    }
                    titulo = 'Erro '+arg.erro;
                    tex = arg.msg;
                }

                    let txt = '';

                    if(arg.zerou == '1'){
                        titulo = arg.empresa;
                        tex = this._msg.getMsg('CARTAO_AVISO_ZERADO', txt);
                    }
                
                let alert = this.alertCtrl.create({
                        title: titulo,
                        subTitle: tex,
                        buttons: [
                        {
                            text: 'OK'
                        }
                        ]
                    });
                alert.present();
                
            });
        }
    }
}


@Component({
	selector: 'page-popover',
	templateUrl: 'popover.html',
})

export class PopoverPage {

	pages = [];
    id_emp = 0;

	constructor(public viewCtrl: ViewController, private _msg: TranslateMsgProvider, private storage: Storage, public nav: NavController, public modalCtrl : ModalController, public events: Events)
	{
        let todaspags = [
            { title: this._msg.getMsg('MENU_CARTAO'),	   component: CartaofidelidadePage, empresa: true , classe: 'item item-block item-md item-hide' },
            { title: this._msg.getMsg('MENU_DADOS'),  	   component: DadosPage, 			empresa: false, classe: 'item item-block item-md item-hide' },
            { title: this._msg.getMsg('MENU_INFORMACOES'), component: EmpresaPage, 			empresa: true , classe: 'item item-block item-md item-hide' },
            { title: this._msg.getMsg('MENU_REGRAS'), 	   component: RegrasPage, 			empresa: true , classe: 'item item-block item-md item-hide' },
            { title: this._msg.getMsg('MENU_MENSAGENS'),   component: MensagensPage, 		empresa: true , classe: 'item item-block item-md item-hide' },
            { title: this._msg.getMsg('MENU_HISTORICO'),   component: HistoricoPage, 		empresa: true , classe: 'item item-block item-md item-hide' },
            { title: this._msg.getMsg('MENU_SOBRE'),       component: SobrePage, 			empresa: false, classe: 'item item-block item-md item-hide' },
            // { title: this._msg.getMsg('MENU_OUTRALOJA'),   component: HomePage, 			empresa: false, classe: 'item item-block item-md item-hide' },
            { title: this._msg.getMsg('MENU_IDIOMA'), 	   component: 'idioma', 			empresa: false, classe: 'item item-block item-md item-hide' },
            { title: this._msg.getMsg('MENU_SAIR'), 	   component: 'sair', 				empresa: false, classe: 'item item-block item-md item-hide' },
        ];

        this.pages = todaspags;

        this.storage.get('id_empresa_escolhida').then((id) =>
        {
            this.id_emp = id;
        	for (var i = 0; i < this.pages.length; ++i)
        	{
        		if((!this.pages[i].empresa) || ((id != 0) && (id != null)))
        		{
        			this.pages[i].classe = 'item item-block item-md';
        		}
        	}
        });
	}

	gopage(page) {
        if(page.component == 'sair')
        {
            this.storage.get('lng').then((lng) => {
                this.storage.clear();
                this.storage.set('lng', lng);
                page.component = LoginPage;
                this.nav.setRoot(page.component);
            });
        }
        else if(page.component == 'idioma')
        {
            this.openModalLng();
        }
        else
        {
            this.events.publish('gotopage', {page: page.component, id: this.id_emp});
        }
        this.viewCtrl.dismiss();
	}

	// Abrir modal de linguas
    openModalLng()
    {
        let modalLng = this.modalCtrl.create(LinguaPage);
        modalLng.present();
    }
}


// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts